// extracted by mini-css-extract-plugin
export default {"containerBackground":"OrganizationOverviewAdmin_containerBackground__xU-ay","Background":"OrganizationOverviewAdmin_Background__JNbrI"};